import { render, staticRenderFns } from "./direct-to-lender-app-summary.vue?vue&type=template&id=5f0ffc2d"
import script from "./direct-to-lender-app-summary.vue?vue&type=script&lang=js"
export * from "./direct-to-lender-app-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports